import { t_dataName } from 'src/app/services/apiHandler/basicMachineFunctions/basic-machine-functions.service';

export type t_EquipmentCurrentsDataPoint = {
    generalName: string;
    dataName: t_dataName;
    unit: string;
    value?: number;
    position: e_Positions;
};

export type t_EquipmentCurrentsDataset = {
    dataPoints: t_EquipmentCurrentsDataPoint[];
};

export enum e_Positions {
    Boom,
    Engine_Uppercarriage, //Cabine
    Undercarriage, //Drive
    Equipment, // Fork, Tele -> Ausrüstung
    Hydraulic_Addition,
}

export var initEquipmentCurrentDataset: t_EquipmentCurrentsDataset = {
    dataPoints: [
        {
            generalName: 'DATANAMES.CURRENT.BOOM_HOIST',
            dataName: {
                name: 'BoomHoistCurrent',
            },
            unit: 'mA',
            position: e_Positions.Boom,
        },
        {
            generalName: 'DATANAMES.CURRENT.BOOM_LOWER',
            dataName: {
                name: 'BoomLowerCurrent',
            },
            unit: 'mA',
            position: e_Positions.Boom,
        },
        {
            generalName: 'DATANAMES.CURRENT.BOOM_LOWER_PF',
            dataName: {
                name: 'BoomPipeFractureCurrent',
            },
            unit: 'mA',
            position: e_Positions.Boom,
        },
        {
            generalName: 'DATANAMES.CURRENT.FAN',
            dataName: {
                name: 'FanCurrent',
            },
            unit: 'mA',
            position: e_Positions.Engine_Uppercarriage,
        },
        {
            generalName: 'DATANAMES.CURRENT.CABINE_HOIST',
            dataName: {
                name: 'CabineHoistCurrent',
            },
            unit: 'mA',
            position: e_Positions.Engine_Uppercarriage,
        },
        {
            generalName: 'DATANAMES.CURRENT.CABINE_LOWER',
            dataName: {
                name: 'CabineLowerCurrent',
            },
            unit: 'mA',
            position: e_Positions.Engine_Uppercarriage,
        },
        {
            generalName: 'DATANAMES.CURRENT.DRIVE_FORWARD',
            dataName: {
                name: 'DriveForwardCurrent',
            },
            unit: 'mA',
            position: e_Positions.Undercarriage,
        },
        {
            generalName: 'DATANAMES.CURRENT.DRIVE_BACKWARD',
            dataName: {
                name: 'DriveBackwardCurrent',
            },
            unit: 'mA',
            position: e_Positions.Undercarriage,
        },
        {
            generalName: 'DATANAMES.CURRENT.HYDRO_DIS',
            dataName: {
                name: 'HydrostatDisplacmentCurrent',
            },
            unit: 'mA',
            position: e_Positions.Undercarriage,
        },
        {
            generalName: 'DATANAMES.CURRENT.HYDRO_PCOR',
            dataName: {
                name: 'HydrostatPCORCurrent',
            },
            unit: 'mA',
            position: e_Positions.Undercarriage,
        },
        {
            generalName: 'DATANAMES.CURRENT.FORK_TILT_IN',
            dataName: {
                name: 'ForkTiltInCurrent',
            },
            unit: 'mA',
            position: e_Positions.Equipment,
        },
        {
            generalName: 'DATANAMES.CURRENT.FORK_TILT_OUT',
            dataName: {
                name: 'ForkTiltOutCurrent',
            },
            unit: 'mA',
            position: e_Positions.Equipment,
        },
        {
            generalName: 'DATANAMES.CURRENT.TELE_EXTEND',
            dataName: {
                name: 'TeleExtendCurrent',
            },
            unit: 'mA',
            position: e_Positions.Equipment,
        },
        {
            generalName: 'DATANAMES.CURRENT.TELE_RETRACT',
            dataName: {
                name: 'TeleRetractCurrent',
            },
            unit: 'mA',
            position: e_Positions.Equipment,
        },
        {
            generalName: 'DATANAMES.CURRENT.SHS13_A_CURR',
            dataName: {
                name: 'SHS13ACurent',
            },
            unit: 'mA',
            position: e_Positions.Hydraulic_Addition,
        },
        {
            generalName: 'DATANAMES.CURRENT.SHS13_B_CURR',
            dataName: {
                name: 'SHS13BCurrent',
            },
            unit: 'mA',
            position: e_Positions.Hydraulic_Addition,
        },
        {
            generalName: 'DATANAMES.CURRENT.SHS2_A_CURR',
            dataName: {
                name: 'SHS2ACurrent',
            },
            unit: 'mA',
            position: e_Positions.Hydraulic_Addition,
        },
        {
            generalName: 'DATANAMES.CURRENT.SHS2_B_CURR',
            dataName: {
                name: 'SHS2BCurrent',
            },
            unit: 'mA',
            position: e_Positions.Hydraulic_Addition,
        },
    ],
};
